import React from 'react';
import { useIntl } from '@olxpwa-lib/i18n/client';
import { TestId } from '~testId';
import { blockDatesLegend } from '../translations';
import {
    StyledContainer,
    StyledDotInformation,
    StyledLegendWrapper,
    StyledLineInformation,
    StyledP4
} from './BlockDatesLegend.components';

const BlockDatesLegend = () => {
    const { formatMessage } = useIntl();
    const currentDate = new Date().getDate();

    return (
        <StyledLegendWrapper data-testid={TestId.blockDatesWrapperLegend}>
            {blockDatesLegend.map(
                ({
                    id,
                    defaultMessage,
                    isAvailableDates,
                    isDotInformation
                }) => {
                    const InformationComponent = isDotInformation
                        ? StyledDotInformation
                        : StyledLineInformation;
                    return (
                        <StyledContainer
                            data-testid={TestId.blockDatesLegendItem}
                            key={id}
                        >
                            <InformationComponent
                                availableDates={isAvailableDates}
                            >
                                {currentDate}
                            </InformationComponent>
                            <StyledP4>
                                {formatMessage({
                                    id,
                                    defaultMessage
                                })}
                            </StyledP4>
                        </StyledContainer>
                    );
                }
            )}
        </StyledLegendWrapper>
    );
};

export default BlockDatesLegend;
